
import { Button, Card, Grid, Notification, NotificationProps, Space, Text } from '@mantine/core'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { doc, updateDoc } from 'firebase/firestore';
import { areEqualArrays } from '../../utils';
import { ConfigDataType } from '../../types';
import { ConfigContext, MyUserDataContext } from '../../contexts';
import UserGroupsSearch from '../../components/user_groups_search';
import { useFirestore } from '../../helpers/firebaseContext';






const ApproversSettings = () => {

    const configContext: ConfigDataType = useContext(ConfigContext);
    const appContext: any = useContext(MyUserDataContext);

    const db = useFirestore();

    const [executiveApprovers, setExecutiveApprovers] = useState<string[]>([]);
    const [normalApprovers, setNormalApprovers] = useState<string[]>([]);
    const [genevaCreateApprovers, setGenevaCreateApprovers] = useState<string[]>([]);
    const [genevaApproveApprovers, setGenevaApproveApprovers] = useState<string[]>([]);
    const [genevaFullApprovers, setGenevaFullApprovers] = useState<string[]>([]);
    const [notificationData, setNotificationData] = useState<null | NotificationProps>();

    const sorted = (values?: string[]) => values ? [...values].sort() : [];

    const originalValues = useMemo(() => ({
        kyc_executive: sorted(configContext?.approvers?.kyc_executive),
        kyc_normal: sorted(configContext?.approvers?.kyc_normal),
        geneva_requests_create: sorted((configContext?.approvers as any)?.geneva_requests_create),
        geneva_requests_approve: sorted((configContext?.approvers as any)?.geneva_requests_approve),
        geneva_requests_full: sorted((configContext?.approvers as any)?.geneva_requests_full),
    }), [configContext?.approvers]);

    useEffect(() => {
        setExecutiveApprovers(originalValues.kyc_executive);
        setNormalApprovers(originalValues.kyc_normal);
        setGenevaCreateApprovers(originalValues.geneva_requests_create);
        setGenevaApproveApprovers(originalValues.geneva_requests_approve);
        setGenevaFullApprovers(originalValues.geneva_requests_full);
    }, [originalValues]);

    const handleChangeExecutiveApprovers = (values: string[]) => {
        setExecutiveApprovers(sorted(values));
    }

    const handleChangeNormalApprovers = (values: string[]) => {
        setNormalApprovers(sorted(values));
    }

    const handleChangeGenevaCreate = (values: string[]) => {
        setGenevaCreateApprovers(sorted(values));
    }

    const handleChangeGenevaApprove = (values: string[]) => {
        setGenevaApproveApprovers(sorted(values));
    }

    const handleChangeGenevaFull = (values: string[]) => {
        setGenevaFullApprovers(sorted(values));
    }

    const updateApprovers = (key: keyof typeof originalValues, values: string[]) => {
        setNotificationData(null)

        const configCollectionRef = doc(db, "config", "approvers");
        const docData: any = {
            updatedBy: appContext?.msal?.account?.username,
        };
        docData[key] = values;

        updateDoc(configCollectionRef, {
            ...docData
        }).then(() => {
            setNotificationData({ color: "green", children: <>Approvers updated Successfully</> })
        }).catch(() => {
            setNotificationData({ color: "red", children: <>Approvers Failed to Update</> })

        });
    }

    const resetApprovers = (key: keyof typeof originalValues) => {
        setNotificationData(null)
        switch (key) {
            case "kyc_executive":
                setExecutiveApprovers(originalValues.kyc_executive);
                break;
            case "kyc_normal":
                setNormalApprovers(originalValues.kyc_normal);
                break;
            case "geneva_requests_create":
                setGenevaCreateApprovers(originalValues.geneva_requests_create);
                break;
            case "geneva_requests_approve":
                setGenevaApproveApprovers(originalValues.geneva_requests_approve);
                break;
            case "geneva_requests_full":
                setGenevaFullApprovers(originalValues.geneva_requests_full);
                break;
            default:
                break;
        }
    }

    const hasChanges = (key: keyof typeof originalValues, current: string[]) => !areEqualArrays(current, originalValues[key]);

    return (
        <Card shadow="sm" p="xl" radius="md" withBorder>
            <Grid
                justify='flex-start'
                ta='center'
            >
                <Grid.Col span={{ xs: 12 }}>
                    <Text fw={700} m={"xl"}>Approvers</Text>
                </Grid.Col>

                {notificationData && <Grid.Col span={{ xs: 12 }}>

                    <Notification {...notificationData} onClose={() => setNotificationData(null)} />
                </Grid.Col>}

                <Grid.Col span={{ lg: 6, xs: 12 }}  >
                    <Grid.Col span={{ xs: 12 }}  >
                        <UserGroupsSearch values={executiveApprovers} label={"Executive Approvers"} onItemSubmit={handleChangeExecutiveApprovers} apiURl={"/groups/"} />
                    </Grid.Col>
                </Grid.Col>
                {hasChanges("kyc_executive", executiveApprovers) && <Grid.Col span={{ lg: 6, xs: 12 }}  >
                    {/* <Card shadow="sm" padding="lg" radius="md" withBorder> */}
                    <Grid justify='flex-start'>



                        <Grid.Col span={{ lg: 3, xs: 6 }}  >

                            <Button
                                color={"green"}
                                variant='outline'
                                onClick={() => updateApprovers("kyc_executive", executiveApprovers)}
                            >
                                Submit Change
                            </Button>
                        </Grid.Col>
                        <Grid.Col span={{ lg: 3, xs: 6 }}  >

                            <Button
                                variant='outline'
                                c={"red"}
                                onClick={() => resetApprovers("kyc_executive")}
                            >
                                Cancel
                            </Button>
                        </Grid.Col>
                    </Grid>

                    {/* </Card> */}

                </Grid.Col>}

            </Grid >
            <Space h="xl" />



            <Grid
                justify='flex-start'
                ta='center'
            >


                <Grid.Col span={{ lg: 6, xs: 12 }}  >
                    <Grid.Col span={{ xs: 12 }}  >

                        <UserGroupsSearch values={normalApprovers} label={"Normal Approvers"} onItemSubmit={handleChangeNormalApprovers} apiURl={"/groups/"} />

                    </Grid.Col>
                </Grid.Col>
                {hasChanges("kyc_normal", normalApprovers) && <Grid.Col span={{ lg: 6, xs: 12 }}  >
                    {/* <Card shadow="sm" padding="lg" radius="md" withBorder> */}
                    <Grid justify='flex-start'>



                        <Grid.Col span={{ lg: 3, xs: 6 }}  >

                            <Button
                                color={"green"}
                                variant='outline'

                                onClick={() => updateApprovers("kyc_normal", normalApprovers)}
                            >
                                Submit Change
                            </Button>
                        </Grid.Col>
                        <Grid.Col span={{ lg: 3, xs: 6 }}  >

                            <Button
                                variant='outline'
                                c={"red"}
                                onClick={() => resetApprovers("kyc_normal")}
                            >
                                Cancel
                            </Button>
                        </Grid.Col>
                    </Grid>

                    {/* </Card> */}

                </Grid.Col >}

            </Grid >

            <Space h="xl" />

            <Grid
                justify='flex-start'
                ta='center'
            >
                <Grid.Col span={{ xs: 12 }}>
                    <Text fw={700} m={"xl"}>Geneva Request Privileges</Text>
                </Grid.Col>

                <Grid.Col span={{ lg: 6, xs: 12 }}>
                    <Grid.Col span={{ xs: 12 }}>
                        <UserGroupsSearch values={genevaCreateApprovers} label={"Create / Edit"} onItemSubmit={handleChangeGenevaCreate} apiURl={"/groups/"} />
                    </Grid.Col>
                </Grid.Col>
                {hasChanges("geneva_requests_create", genevaCreateApprovers) && (
                    <Grid.Col span={{ lg: 6, xs: 12 }}>
                        <Grid justify='flex-start'>
                            <Grid.Col span={{ lg: 3, xs: 6 }}>
                                <Button
                                    color={"green"}
                                    variant='outline'
                                    onClick={() => updateApprovers("geneva_requests_create", genevaCreateApprovers)}
                                >
                                    Submit Change
                                </Button>
                            </Grid.Col>
                            <Grid.Col span={{ lg: 3, xs: 6 }}>
                                <Button
                                    variant='outline'
                                    c={"red"}
                                    onClick={() => resetApprovers("geneva_requests_create")}
                                >
                                    Cancel
                                </Button>
                            </Grid.Col>
                        </Grid>
                    </Grid.Col>
                )}

                <Grid.Col span={{ lg: 6, xs: 12 }}>
                    <Grid.Col span={{ xs: 12 }}>
                        <UserGroupsSearch values={genevaApproveApprovers} label={"Approve"} onItemSubmit={handleChangeGenevaApprove} apiURl={"/groups/"} />
                    </Grid.Col>
                </Grid.Col>
                {hasChanges("geneva_requests_approve", genevaApproveApprovers) && (
                    <Grid.Col span={{ lg: 6, xs: 12 }}>
                        <Grid justify='flex-start'>
                            <Grid.Col span={{ lg: 3, xs: 6 }}>
                                <Button
                                    color={"green"}
                                    variant='outline'
                                    onClick={() => updateApprovers("geneva_requests_approve", genevaApproveApprovers)}
                                >
                                    Submit Change
                                </Button>
                            </Grid.Col>
                            <Grid.Col span={{ lg: 3, xs: 6 }}>
                                <Button
                                    variant='outline'
                                    c={"red"}
                                    onClick={() => resetApprovers("geneva_requests_approve")}
                                >
                                    Cancel
                                </Button>
                            </Grid.Col>
                        </Grid>
                    </Grid.Col>
                )}

                <Grid.Col span={{ lg: 6, xs: 12 }}>
                    <Grid.Col span={{ xs: 12 }}>
                        <UserGroupsSearch values={genevaFullApprovers} label={"Create / Edit & Approve"} onItemSubmit={handleChangeGenevaFull} apiURl={"/groups/"} />
                    </Grid.Col>
                </Grid.Col>
                {hasChanges("geneva_requests_full", genevaFullApprovers) && (
                    <Grid.Col span={{ lg: 6, xs: 12 }}>
                        <Grid justify='flex-start'>
                            <Grid.Col span={{ lg: 3, xs: 6 }}>
                                <Button
                                    color={"green"}
                                    variant='outline'
                                    onClick={() => updateApprovers("geneva_requests_full", genevaFullApprovers)}
                                >
                                    Submit Change
                                </Button>
                            </Grid.Col>
                            <Grid.Col span={{ lg: 3, xs: 6 }}>
                                <Button
                                    variant='outline'
                                    c={"red"}
                                    onClick={() => resetApprovers("geneva_requests_full")}
                                >
                                    Cancel
                                </Button>
                            </Grid.Col>
                        </Grid>
                    </Grid.Col>
                )}
            </Grid>

        </Card >
    )
}

export default ApproversSettings
